/*
 * @Description:
 * @Date: 2021-03-22 00:10:03
 */
import { isNavigationFailure, Router } from 'vue-router';
import NProgress from 'nprogress';
// import intercept from './intercept/index';

NProgress.configure({ showSpinner: false });

export async function createRouterGuards(router: Router) {
  router.beforeEach(async (to, from, next) => {
    NProgress.start();
    /* 
      在路由拦截中处理异步函数（例如接口调用）会导致路由报错：Error: Invalid navigation guard。
    */
    // await intercept.whiteIntercept();
    // await intercept.loginIntercept();
    // await intercept.menuIntercept();
    // await intercept.dataIntercept();
    next();
  });

  router.afterEach((to, from, failure) => {
    if (isNavigationFailure(failure)) {
      console.log('failed navigation', failure);
    }
    const scrollDom = document.querySelector(
      '#right-scroll-block .el-scrollbar__wrap'
    );
    if (scrollDom && scrollDom?.scrollTop && !to.meta.keepAlive) {
      scrollDom.scrollTo(0, 0);
    }

    // 解决跳转时滚动条高度跟随问题
    const main = document.querySelector('.layout__main');
    if (main && main.scrollTop) {
      main.scrollTop = 0;
    }
    NProgress.done();
  });

  router.onError(error => {
    console.log(error, '路由错误');
  });
}
